import React, { useState } from 'react';
import { tableFormat } from '../../../config/tableFormat';
import moment from 'moment';

const ApprovalTable = (props) => {
    const [loader, setLoader] = useState(false);

    const includeColumns =[
        "Customer",
        "UAT ID",
        "Request Status",
        "GPU",
        "# of GPUs Requested",
        "Region Requested",
        "Date Needed",
        "AI GBB"
      ]
    // Filtered headers and keys
    const filteredHeaderLabels = tableFormat.headerLabels.filter(label => includeColumns.includes(label));
    
    const tableFormatLocal = props.isMail ? { headerLabels: filteredHeaderLabels, keys: filteredHeaderLabels } : tableFormat;
    

    const renderDefaultTable = () => (
        <table style={{ borderCollapse: 'collapse' }} className='auto-width'>
            <thead>
                <tr>
                    {tableFormatLocal.headerLabels.map((label, index) => (
                        <th key={index} style={headerStyle}>
                            {label}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {props.data?.map((row, rowIndex) => (
                    <tr
                        key={rowIndex}
                        style={{
                            backgroundColor: !props.isMail ? props.result?.includes(String(row["RequestID"])) ? '#ffa6a6' : '#f6f6f6' :  '#f6f6f6',
                        }}
                    >
                        {tableFormatLocal.keys.map((label, colIndex) => (
                            <td
                                key={`${rowIndex}-${colIndex}`}
                                style={bodyStyle}
                                title={`Tag :${row['Tag']}`}
                            >
                                {((row[label] && row[label] !== -1 && row[label] !== '-1') || (['GPUsAllocated', 'GPUsRequested', 'GPUsOwed'].includes(label))
                                    ? (label.includes("Date") ? moment(row[label]).format('MM/DD/YYYY') : row[label])
                                    : 'NA')}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );

    return (
        <>
            { renderDefaultTable()}
            {loader && (
                <div className="loader-container">
                    <div className="loader"></div>
                </div>
            )}
        </>
    );
};

const headerStyle = {
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0px',
    textAlign: 'center', 
    verticalAlign: 'middle', 
    backgroundColor: '#e9e9e9',
    color: 'black',
    height: '40px', 
    border: '1px solid #ccc', 
    width: '150px' 
};

const bodyStyle = {
    fontFamily: 'Segoe UI',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0px',
    textAlign: 'center',
    verticalAlign: 'middle',
    height: '40px',
    border: '1px solid #ccc', 
    width: '150px' 
};

const specialStyle = {

    width: "30%", 
    textWrap: 'auto'
};


export default ApprovalTable;